import React from "react";
import { AppBar, Toolbar, IconButton, Typography } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const HeaderBar = ({ title = "", showBack = false }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1); // 🔙 브라우저 뒤로가기
  };

  return (
    <AppBar position="static" color="primary" enableColorOnDark sx={{position:"fixed",top:0,left:0,right:0,zIndex:10}}>
      <Toolbar>
        <IconButton edge="start" color="inherit" onClick={showBack ? handleBack : undefined} sx={{ mr: 2 }}>
          {showBack ? <ArrowBackIcon /> : <MenuIcon />}
        </IconButton>
        <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
          {title}
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

export default HeaderBar;
